import CouponPage, { getServerSideProps } from '@haaretz/s-pp-coupon-page';

export default CouponPage;

export { getServerSideProps };
